import { render, staticRenderFns } from "./ParcelSupportingDocumentsSection.vue?vue&type=template&id=65c50651&scoped=true&"
import script from "./ParcelSupportingDocumentsSection.vue?vue&type=script&lang=js&"
export * from "./ParcelSupportingDocumentsSection.vue?vue&type=script&lang=js&"
import style0 from "./ParcelSupportingDocumentsSection.vue?vue&type=style&index=0&id=65c50651&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c50651",
  null
  
)

export default component.exports